module.exports = __webpack_public_path__ + "static/media/global.4e042d16.jpeg";